let link = window.location.href
let market = link.includes('en-us') ? '/en-us/' : link.includes('en-int') ? '/en-int/' : '/'

// fix announcement links
document.querySelectorAll('.announcement-text a').forEach(function(link) {
    link.href = link.href.replace('.com/', `.com${market}`)
})
// end of fix announcement links

if(!link.includes('/recurring/login')) {
    localStorage.setItem("prevMarket", market)
} else {
    setTimeout(() => {
        if(document.querySelector('.rc_layout__container')) {
            document.querySelector('.rc_layout__container a').href = localStorage.getItem('prevMarket') + 'account'
        }
    }, 1000);
}

if(!window.location.href.includes('?viewcart')) {
    localStorage.setItem("market", market)

    document.addEventListener('rebuy:cart.change', (event) => { 
        let items = null
        
        if(event.detail.cart.cart.item_count > 0) {
            items = []
            event.detail.cart.cart.items.forEach(function(item) {
                items.push({
                    id: item.id,
                    quantity: item.quantity 
                })
            })
        }
    
        localStorage.setItem("items", JSON.stringify(items))
    });
} 


let events = ['rebuy:cart.ready', 'rebuy:cart.change']
events.forEach(function(e) {
    document.addEventListener(e, (event) => {
        setTimeout(() => {
            if(document.querySelector('.rebuy-cart__flyout-empty-cart')) {
                let market = link.includes('en-us') ? '/en-us/' : link.includes('en-int') ? '/en-int/' : '/'
                document.querySelector('.rebuy-cart__flyout-empty-cart a').href = market + 'collections/pain-relief-devices'
            }
        }, 1000);
    })
})


if(window.location.href.includes('?viewcart')) {
    fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
        let items = JSON.parse(localStorage.getItem('items'))

        if(items?.length && cart.item_count == 0) {

            let formData = {
                'items': items
            };

            fetch(window.Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
                headers: {
                'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
            })
            .then(response => {
                const Cart = window.Rebuy.Cart;
                Cart.getCart()
                
            })
            .catch((error) => {
                console.error('Error:', error);
            });
        }

        
        const observer = new MutationObserver((mutationsList, observer) => {
            const targetElement = document.getElementById('rebuy-cart');
            
            if (targetElement) {

              observer.disconnect();
              setTimeout(() => {
                document.querySelector('a.cart').click() 
              });
            }
          });
        
          const observerConfig = {
            childList: true, 
            subtree: true,   
          };
        
        observer.observe(document.documentElement, observerConfig);

        const newURL = new URL(window.location.href).origin + new URL(window.location.href).pathname;
        history.replaceState(null, '', newURL);

    })
    .catch(error => console.error('There was an error fetching the cart:', error));
}